export const googleClientID = '364160058081-441lfht07po75ebif3ldppo7el2u3468.apps.googleusercontent.com'
export const googleClientSecret = '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'
export const fbAppID= '891506738543265'

// clientID = '764273079262-n48an6t1ui6rjrif2hhu66b44ctfodtn.apps.googleusercontent.com'
// clientSecret = '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'